/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshiptypeId200,
  GetApiV1ScholarshiptypeId401,
  GetApiV1ScholarshiptypeId404,
  GetApiV1ScholarshiptypeId500,
  GetApiV1ScholarshiptypeIdPathParams,
  GetApiV1ScholarshiptypeIdQueryResponse,
} from "../../types/scholarshipTypeRegistroController/GetApiV1ScholarshiptypeId.ts";
import { scholarshipTypeViewModelSchema } from "../scholarshipTypeViewModelSchema.ts";

export const getApiV1ScholarshiptypeIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ScholarshiptypeIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshiptypeId200Schema = z.lazy(
  () => scholarshipTypeViewModelSchema,
) as unknown as ToZod<GetApiV1ScholarshiptypeId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshiptypeId401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ScholarshiptypeId404Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshiptypeId500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeId500>;

export const getApiV1ScholarshiptypeIdQueryResponseSchema = z.lazy(
  () => getApiV1ScholarshiptypeId200Schema,
) as unknown as ToZod<GetApiV1ScholarshiptypeIdQueryResponse>;
